import React, { ReactNode } from "react";
import { css } from "@emotion/react";

type Props = {
    children: ReactNode,
};

const CartImageAndTitleContainer: React.FC<Props> = ({ children }) => {
    const style = css`
        display: flex;
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default CartImageAndTitleContainer;